import { render, staticRenderFns } from "./ProjectTemplate4.vue?vue&type=template&id=dae0345e&scoped=true"
import script from "./ProjectTemplate4.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate4.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate4.vue?vue&type=style&index=0&id=dae0345e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae0345e",
  null
  
)

export default component.exports